module.exports = __webpack_public_path__ + "img/icon_dpi_active.fefdd49f.svg";